

  <div class="mt-10">
    <nchl-vertical-menu [items]="menuItems"></nchl-vertical-menu>
  </div>
